import { SvgExportDef, TLShapeId, toDomPrecision } from '@tldraw/tldraw'
import { TextBoxShapeProps } from './Types'

type ShadowResult = {
  id: string
  svgExportDef: SvgExportDef
}

export const getShadow = ({
  id: shapeId,
  w,
  h,
  shadow,
}: { id: TLShapeId; w: number; h: number } & Pick<TextBoxShapeProps, 'shadow'>): ShadowResult => {
  const id = `${shapeId}_shadow`

  if (!shadow) {
    return {
      id,
      svgExportDef: {
        key: id,
        getElement: () => [],
      },
    }
  }

  const filterWidth = toDomPrecision(w + Math.abs(shadow.x) + shadow.blur * 2)
  const filterHeight = toDomPrecision(h + Math.abs(shadow.y) + shadow.blur * 2)
  const filterX = -shadow.blur
  const filterY = -shadow.blur

  return {
    id,
    svgExportDef: {
      key: id,
      getElement: () => {
        const divEl = document.createElement('div')
        divEl.innerHTML = `
          <svg>
            <defs>
              <filter
                id="${id}"
                x="${filterX - Math.max(0, -shadow.x)}"
                y="${filterY - Math.max(0, -shadow.y)}"
                width="${filterWidth}"
                height="${filterHeight}"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
              >
                <feDropShadow
                  dx="${shadow.x}"
                  dy="${shadow.y}"
                  stdDeviation="${shadow.blur / 2}"
                  flood-opacity="${shadow.opacity}"
                  flood-color="${shadow.color}"
                />
              </filter>
            </defs>
          </svg>
        `
        return Array.from(divEl.querySelectorAll('defs > *'))
      },
    },
  }
}
